export enum CONSTANT {
ENG = "eng",
PATTERN = "^\\d*(\\.?\\d{1,2})?$"
}
